/*
 * @Author: tony.zhu
 * @Date: 2025-09-25 17:47:43
 * @LastEditTime: 2025-12-25 10:41:30
 * @LastEditors: tony.zhu
 * @Description:  原生方法
    this.eventSourceInstance = new EventSource({
        url: conf.VUE_APP_BASE_API + "assessment/gpt/make",
        });
        this.eventSourceInstance.onMessage((e) => {
        try {
            if (e instanceof Error) {
            throw e;
            }
            if (e.data) {
            }
        } catch (error) {
            console.log(error);
            this.eventSourceInstance.onClose();
        }
        });

    @microsoft/fetch-event-source 依赖方法
    accept: text/event-stream 请求头
    用的fetch 响应流方法 stream
 */

import { fetchEventSource } from '@microsoft/fetch-event-source'
import EventEmitter from 'events'
import { getCookie, removeToken, setCookie } from '@/utils/auth'
import { getString } from './validate.js'
import { baseApi } from '@/config'
// import {
//     API
// } from "http/api";
import Storage from './storage'
export class FetchEventSourceManager extends EventEmitter {
  constructor() {
    super()
    this.isLoading = false
    this.abortController = null // 保存 AbortController 实例
    this.defaultSettings = {
      method: 'POST',
      openWhenHidden: true,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    this._vm = null

    this.dialogueMap = new Map()
  }

  onLogout() {
    this.emit('on-logout')
  }

  onSetVm(vm) {
    this._vm = vm
  }

  async onSend(body = {}, cb = () => {}) {
    return new Promise((resolve, reject) => {
      const handle = async params => {
        let config = {
          __retryCount: 0,
          timer: null,
          ...params
        }
        try {
        //   let { key, value } = getCookie()
        //   if (value) {
        //     this.defaultSettings.headers[key] = value
        //   }
        //   if (['development', 'dev'].includes(window.__VUE3__.NODE_ENV)) {
        //     // 如果是本地联调 非pre地址
        //     if (window.__apiBaseUrl__.indexOf('192.') >= 0) {
        //       // this.defaultSettings.headers['X-Account'] = xAccount
        //       // if (API.sendQuestionSseEmitter.indexOf('personnel-assessment-enterprise') >= 0) {
        //       //     API.sendQuestionSseEmitter = API.sendQuestionSseEmitter.split('personnel-assessment-enterprise')[1]
        //       // }
        //     }
        //   }
          this.isLoading = true
          config = {
            ...config,
            body: JSON.stringify({
              ...body
            }),
            //...this.defaultSettings,
            onopen: e => {
              this.onOpen(e, JSON.parse(JSON.stringify(config)))
            },
            onmessage: e => {
              this.onMessage(e, JSON.parse(JSON.stringify(config)))
            },
            onclose: e => {
              this.onClose(e, JSON.parse(JSON.stringify(config)))
            },
            onerror: e => {
              this.onError(e, JSON.parse(JSON.stringify(config)))
            }
          }
          //debugger
          cb()

          this.abortController = new AbortController() // 创建 AbortController 实例
          const url = baseApi + '/api/zzp-recruit/chat/chat';
          const eventSource = await fetchEventSource(url, {
            method: 'POST',
            signal: this.abortController.signal,
            headers: {
              'Content-Type': 'application/json',
              'dhr-Token': getCookie('dhr-Token')
            },
            ...config,
            openWhenHidden: true // 防止浏览器标签切换时触发重连
          })
        } catch (error) {
          console.log(error, 'catch')
          this.isLoading = false
          this.onCloseLink({})
          // 不重试 - SSE 是单次请求-响应，失败后由用户手动重发
          // 重试会导致浏览器窗口切走再切回时创建重复 /chat/chat 连接
        }
        resolve(config)
      }

      handle({})
    })
  }

  async onOpen(e, config) {
    const ContentType = e.headers.get('Content-Type')
    const body = JSON.parse(config.body)

    // 设置对话记录本地保存
    if (body && body.id) {
      this.dialogueMap.set(body.id, body)
      Storage.set('dialogueMap', JSON.stringify(Array.from(this.dialogueMap.entries())))
    }
    console.log(e.headers, 'headers')
    if (ContentType == 'application/json') {
      // 证明 流关闭 产生错误（连接未成功）
      const json = await e.json()
      if (json.code == 401) {
        // 清本地token
        // 跳转登录页
        this.onLogout()
        return
      }
      if (json.code !== 200) {
        // 错误数据
        const text = {
          message: json.message || '操作失败',
          type: 'error'
        }
        if (window.MODESIGN) {
          window.MODESIGN.Message(text)
        } else {
          this._vm.$message(text)
        }
        this.emit('on-error', {
          data: e,
          body
        })
        return
      }
    }

    if (e.status == 401) {
      // 清本地token
      // 跳转登录页
      this.onLogout()
      return
    }
  }

  onMessage(source, config) {
    const data = getString(source.data)
    const body = JSON.parse(config.body)
    if (data && data.data.status) {
      switch (data.data.status) {
        case 'error':
          // TODO 因为每次都是问后 禁止 才可以这么删除
          this.isLoading = false
          this.onClearDialogueMap(config)
          this.emit('on-error', {
            data,
            body
          })
          // throw new Error("OpenAI出现异常，返回ERROR!");

          this.onCloseLink({})
          break

        case 'done':
          console.log('关闭', '[DONE]', '服务关闭', data)
          this.onClearDialogueMap(config)
          this.isLoading = false
          this.emit('on-close', {
            data,
            body
          })

          break

        case 'answer':
          this.emit('on-message', {
            data,
            body
          })
          break
      }
    }
  }

  onClose(e, config) {
    console.log('关闭', 'close', config)
    this.onClearDialogueMap(config)
    this.isLoading = false
    this.emit('on-close', {})
    this.onCloseLink({})
  }

  onError(err, config) {
    console.log(err, 'error', config)
    this.onClearDialogueMap(config)
    this.isLoading = false
    // 不要在这里调用 onCloseLink，让 catch 块统一处理清理
    // 避免重试逻辑创建重复连接
    throw new Error('连接异常')
  }

  onClearDialogueMap(config) {
    console.log(config)
    const body = JSON.parse(config.body)

    if (body && body.id) {
      // 清除对话记录
      try {
        const dialogueMap = Storage.get('dialogueMap')
        this.dialogueMap = new Map(dialogueMap)
        this.dialogueMap.delete(body.id)
        Storage.set('dialogueMap', JSON.stringify(Array.from(this.dialogueMap.entries())))
      } catch (error) {
        console.log(error, 'error')
      }
    }
  }

  onCloseLink({ isManualClose = false }) {
    try {
      if (this.abortController) {
        this.isLoading = false
        this.abortController.abort()
        this.abortController = null
      }
      if (isManualClose) {
        this.emit('on-manual-close-link', {})
      }
      this.emit('on-close-link', {})
    } catch (error) {
      console.log(error)
    }
  }

  onGetLoading() {
    return this.isLoading
  }
}

export const fetchEventSourceManager = new FetchEventSourceManager()
